import { render, staticRenderFns } from "./CoForm.vue?vue&type=template&id=5985034d&"
import script from "./CoForm.vue?vue&type=script&lang=ts&"
export * from "./CoForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports